var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Metadata") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.84,
    y: 3.16,
    width: 16.32,
    height: 17.68,
    rx: 2.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24 6.56 L14.04 6.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96 10.64 L16.76 10.64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96 14.04 L15.4 14.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96 17.44 L17.44 17.44"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.24,
    cy: 10.64,
    r: 0.612,
    fill: "#FFFFFF",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.24,
    cy: 14.04,
    r: 0.612,
    fill: "#FFFFFF",
    stroke: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.24,
    cy: 17.44,
    r: 0.612,
    fill: "#FFFFFF",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadata);
export default __webpack_public_path__ + "static/media/metadata.30b0944d543bc5ccc62d4f57b0241ea0.svg";
export { ForwardRef as ReactComponent };